import { Container, Grid } from "@mui/material";
import React from "react";

const Header = () => {
    return(
        <div className="OS---Header">
            <Container maxWidth="lg" className="py-md-5">
                <Grid 
                    container
                    justifyContent="center"
                    alignContent="center"
                    alignItems="center"
                    className="py-5"
                >
                    <Grid
                        xs={12}
                        md={6}
                    >
                        <h4 className="mb-0">OhmniShiba</h4>
                        <h2 className="my-3">The Decentralized Reserve Currency</h2>
                        <p className="mb-0">Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren.</p>
                    </Grid>
                    <Grid
                        xs={12}
                        md={6}
                        container
                        justifyContent="center"
                        alignContent="center"
                        className="mt-4"
                    >
                        <div
                            className="OS---header-left-Container mt-4"
                        >
                            <Grid
                                xs={12}
                                sm={6}
                                className="text-center py-4"
                            >
                                <p>Total OHMS Staked</p>
                                <h3>89.5%</h3>
                            </Grid>
                            <Grid
                                xs={12}
                                sm={6}
                                className="text-center py-4"
                            >
                                <p>Total OHMS Staked</p>
                                <h3>89.5%</h3>
                            </Grid>
                            <Grid
                                xs={12}
                                sm={6}
                                className="text-center py-4"
                            >
                                <p>Total OHMS Staked</p>
                                <h3>89.5%</h3>
                            </Grid>
                            <Grid
                                xs={12}
                                sm={6}
                                className="text-center py-4"
                            >
                                <p>Total OHMS Staked</p>
                                <h3>89.5%</h3>
                            </Grid>
                        </div>
                    </Grid>
                </Grid>
            </Container>
        </div>
    );
}

export default Header;